export default __webpack_public_path__ + "static/media/stormregalia.f188c7bd.png";